import ActionGroup from './ActionGroup';
import { shouldExpandActionsOnMobile } from '../../utils/actionGroupClasses';

const FormActions = ({
  children,
  className,
  variant = 'task',
  expandChildrenOnMobile,
  ...props
}) => (
  <ActionGroup
    align="end"
    stackOnMobile
    reverseOnMobile
    expandChildrenOnMobile={shouldExpandActionsOnMobile({
      variant,
      expandChildrenOnMobile,
    })}
    className={className}
    {...props}
  >
    {children}
  </ActionGroup>
);

export default FormActions;
